class WCProduct extends WCObservable(WCLockable(WCDummy)) {
  #id;
  #inv;
  #quantity;
  #variant;
  #submit;
  #section;

  static get tag() {
    return "wc-product";
  }

  static get observedAttributes() {
    return ["lock"];
  }

  constructor() {
    super({ tag: WCProduct.tag });
    this.#inv = this.querySelector(".js-inventory-note-message");

    this.#id = this.querySelector("input[type=hidden][name=id]");
    this.#quantity = Array.from(this.querySelectorAll("wc-quantity-selector"));
    this.#variant = this.querySelector("wc-variant-selector");
    this.#submit = this.querySelector("button[type=submit][name=add]");
    this.#section = this.closest("[id^=shopify-section-]").id.replace(
      "shopify-section-",
      ""
    );

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.hasSchema && this.initObserver();
    this.#submit.addEventListener("click", this.handleSubmit);
    this.#quantity.forEach((quantity) => {
      quantity.addEventListener("change", this.handleQuantityChange);
      this.handleQuantityChange({
        srcElement: quantity,
        detail: quantity.value,
      });
    });
    this.#variant?.addEventListener("change", this.handleVariantChange);
  }

  disconnectedCallback() {
    this.#submit.removeEventListener("click", this.handleSubmit);
  }

  observerCallback() {
    AnalyticsLayer.trackItemView([
      {
        id: this.#id.value,
        product_title: document.querySelector('[itemprop="name"]').content,
        vendor: document.querySelector('[itemprop="brand"]').content,
        variant_title: this.querySelector("wc-schema [itemprop=variantTitle]")
          .content,
        price:
          parseFloat(
            this.querySelector('[itemprop="price"]').getAttribute("content")
          ) * 100,
        currency: document.querySelector("wc-schema [itemprop=priceCurrency]")
          .content,
        quantity: parseInt(
          document.querySelector("input[name=quantity]")?.value
        ),
      },
    ]);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "lock":
        if (newValue === "") {
          this.#submit.setAttribute("disabled", "");
          this.#inv?.classList.remove("hidden");
        } else {
          this.#submit.removeAttribute("disabled");
          this.#inv?.classList.add("hidden");
        }
        break;

      default:
        break;
    }
  }

  get hasSchema() {
    return this.querySelector("wc-schema");
  }

  handleSubmit(e) {
    e.preventDefault();
    this.checkConnectedQuantities.bind(this)();
    this.#submit.dataset.state = "adding";
    const quantities = this.#quantity.reduce((result, quantity) => {
      const value = quantity.value;
      if (value > 0) {
        result.push({
          id:
            parseInt(this.#id?.value) ||
            parseInt(quantity.getAttribute("variant-id")),
          quantity: value || 1,
        });
      }
      return result;
    }, []);
    quantities.length &&
      ShopifyAjaxAPI.add(quantities).then(() => {
        this.#submit.dataset.state = "added";
        const cartTrigger = document.querySelector(
          `[trigger="#js-cart-drawer-open"]`
        );
        cartTrigger?.setAttribute("open", "");
        document
          .querySelector(`wc-cart-notification`)
          ?.setAttribute("open", "");
      });
  }

  handleQuantityChange(e) {
    if (e.detail === 0) {
      this.lock({
        item: e.srcElement,
        condition: { id: "quantity", limit: this.#quantity.length },
      });
    } else {
      this.release({ item: e.srcElement });
    }
  }

  handleVariantChange(e) {
    const currentVariant = e.detail;
    fetch(
      `${window.location.pathname}?variant=${currentVariant.id}&sections=${
        this.#section
      }`
    )
      .then((d) => d.json())
      .then((d) => {
        this.lockState = [];
        const doc = parseHTML(d[this.#section]);
        const currentIndex = Array.from(
          document.querySelectorAll("wc-product")
        ).findIndex((item) => item.isEqualNode(this));
        const canidateProduct =
          doc.querySelectorAll("wc-product")[currentIndex];
        const canidates = canidateProduct.querySelectorAll("wc-live-region");
        this.querySelectorAll("wc-live-region").forEach((el, i) => {
          if (el.data.outerHTML !== canidates[i].outerHTML) {
            el.innerHTML = canidates[i].innerHTML;
            el.data = canidates[i];
          }
        });
        // this.#submit = this.querySelector("button[type=submit][name=add]");
        // this.#submit.addEventListener("click", this.handleSubmit);
        this.#inv = this.querySelector(".js-inventory-note-message");
        this.#quantity = Array.from(
          this.querySelectorAll("wc-quantity-selector")
        );
        this.#quantity.forEach((quantity) => {
          quantity.addEventListener("change", this.handleQuantityChange);
          this.handleQuantityChange({
            srcElement: quantity,
            detail: quantity.value,
          });
        });
        this.#id = this.querySelector("input[type=hidden][name=id]");
      });
  }

  checkConnectedQuantities() {
    if (
      this.#quantity.length > 0 &&
      this.#quantity.find((quantity) => !quantity.isConnected)
    ) {
      this.#quantity = Array.from(
        this.querySelectorAll("wc-quantity-selector")
      );
    }
  }
}

customElements.define(WCProduct.tag, WCProduct);
